var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlantIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tabler-icon-seeding"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 12.5001H9.375C7.7174 12.5001 6.12769 11.8416 4.95558 10.6695C3.78348 9.4974 3.125 7.90768 3.125 6.25008V4.16675H6.25C7.9076 4.16675 9.49731 4.82523 10.6694 5.99733C11.8415 7.16943 12.5 8.75914 12.5 10.4167V20.8334M12.5 14.5834C12.5 12.9258 13.1585 11.3361 14.3306 10.164C15.5027 8.99189 17.0924 8.33341 18.75 8.33341H21.875V9.37508C21.875 11.0327 21.2165 12.6224 20.0444 13.7945C18.8723 14.9666 17.2826 15.6251 15.625 15.6251H12.5",
    stroke: "#A37028",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlantIcon);
export default __webpack_public_path__ + "static/media/plantIcon.5ce853188915f250c4be16fd033fdb1e.svg";
export { ForwardRef as ReactComponent };